import { APPLICATION_NAME, EMPTY_STRING } from "../Constants/CommonConstants";
import api from "./AxiosInterceptor";
import EndpointService from "./EndpointService";

export const logError = async (errorData, errorInfo) => {
  const url = EndpointService("logErrorUrl");
  const payload = {
    resourceUrl: EMPTY_STRING,
    serverName: EMPTY_STRING,
    serviceName: EMPTY_STRING,
    correlationId: EMPTY_STRING,
    errorLog: {
      exceptionDt: `${new Date().toISOString()}`,
      exceptionSummary: `${errorData}`,
      exceptionDetail: `${errorInfo?.componentStack}`,
    },
    userName: EMPTY_STRING,
    applicationName: APPLICATION_NAME,
    pageDetails: location.pathname,
  };
  const response = await api.post(url, payload);
  return response.data;
};
